// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2aVju","col":"styles_col__yB5nI"};